import { render, staticRenderFns } from "./LawMatterProcessResultForm.vue?vue&type=template&id=7bbe3144&"
import script from "./LawMatterProcessResultForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterProcessResultForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterProcessResultForm.vue?vue&type=style&index=0&id=7bbe3144&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports